import { render, staticRenderFns } from "./Restrictions.vue?vue&type=template&id=70488829&scoped=true"
import script from "./Restrictions.vue?vue&type=script&lang=js"
export * from "./Restrictions.vue?vue&type=script&lang=js"
import style0 from "./Restrictions.vue?vue&type=style&index=0&id=70488829&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70488829",
  null
  
)

export default component.exports